import PropTypes from 'prop-types';
import LightbulbOutlined from '@mui/icons-material/EmojiObjectsOutlined';
import DeviceSettingsFields from '../../vonage/device_settings/DeviceSettingsFields';
import { sharedDeviceMessage } from '../../vonage/device_settings/messages';
import LiveCaptionsToggle from '../../vonage/live_captions/LiveCaptionsToggle';
import localeMessage from '../localeMessage';

const DeviceSettings = ({
  appointment,
  controller,
  hasVideoSource,
  liveCaptions,
  locale,
}) => {
  const tollFree = appointment.twilio_toll_free_number;
  const pin = appointment.twilio_voice_token;

  return (
    <div className="vonage-device-settings-sidebar">
      <h2>{localeMessage('Settings', locale)}</h2>
      <DeviceSettingsFields
        controller={controller}
        cameraLocked={!hasVideoSource}
        inSession
        t={id => localeMessage(id, locale)}
      />
      {liveCaptions?.available && (
        <LiveCaptionsToggle
          checked={liveCaptions.isEnabled}
          deviceFieldStyle
          disabled={liveCaptions.isStarting}
          onChange={liveCaptions.onChange}
          t={id => sharedDeviceMessage(id, locale)}
        />
      )}
      {tollFree && pin && (
        <div className="vonage-device-settings-sidebar__dial-in">
          <LightbulbOutlined aria-hidden="true" />
          <p>
            {localeMessage('deviceSettings.joinTollFree.before', locale)}
            <a href={`tel:${tollFree}`}>{tollFree}</a>
            {localeMessage('deviceSettings.joinTollFree.after', locale, {
              pin,
            })}
          </p>
        </div>
      )}
    </div>
  );
};

DeviceSettings.propTypes = {
  appointment: PropTypes.object.isRequired,
  controller: PropTypes.object.isRequired,
  hasVideoSource: PropTypes.bool.isRequired,
  liveCaptions: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    isStarting: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  }),
  locale: PropTypes.string.isRequired,
};

export default DeviceSettings;
